// When navigating to a chart item, we don't want to be aligned right to the edge of the viewport
export const NAVIGATE_OFFSET = 32;
